'use client';

import { Container } from '../Container';
import { Card, CardProps } from '../Card';

export type CrossLinkCardProps = Omit<CardProps, 'layout' | 'size'>;

export function CrossLinkCard(props: CrossLinkCardProps) {
	return (
		<Container size='editorial-narrow'>
			<Card {...props} size='xl' layout='horizontal' />
		</Container>
	);
}
